import { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../images/logo.svg";
import { FaPhoneAlt } from "react-icons/fa";

const sections = ["home", "work", "services", "reviews", "about", "contact"];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isHome, setIsHome] = useState(true);
  const [activeLink, setActiveLink] = useState("home");

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
        setIsHome(false);
      } else {
        setIsSticky(false);
        setIsHome(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Intersection Observer API to detect active section
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "-50px 0px -50% 0px",
      threshold: 0.3,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach((sectionId) => {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) observer.observe(sectionElement);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Navbar expand="lg" className={`navbar-dark customhead ${isSticky ? "sticky-navbar fixed-top" : ""}`}>
      <Container>
        <Navbar.Brand href="/">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <img src={logo} alt="Logo" />
          </motion.div>
        </Navbar.Brand>

        <Button href="#contact" className="contact-btn d-lg-none">
          CONTACT
        </Button>

        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setIsOpen(!isOpen)} className="toggle-btn d-lg-none" />

        <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
          <Nav className="ms-auto">
            {sections.map((item, index) => (
              <motion.div
                key={item}
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <Nav.Link
                  className={`text-custom-white me-2 ${activeLink === item ? "active-link" : ""}`}
                  href={`#${item}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveLink(item);

                    const section = document.getElementById(item);
                    if (section) {
                      section.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                  }}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </Nav.Link>
              </motion.div>
            ))}
          </Nav>
          <Nav className="ms-3">
            <motion.div
              className="phone-box"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 }}
              viewport={{ once: false, amount: 0.3 }}
            >
              <Nav.Link href="tel:+61481829998" className="text-white d-flex align-items-center">
                <FaPhoneAlt className="me-1" size={12} /> +61 481 829 998
              </Nav.Link>
            </motion.div>
          </Nav>
        </Navbar.Collapse>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              className="fullscreen-menu d-lg-none"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Nav className="fullscreen-nav">
                {["Home", "Work", "Services", "Reviews", "About", "Contact"].map((item, index) => {
                  const lowerCaseItem = item.toLowerCase();
                  return (
                    <motion.div
                      key={item}
                      initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                      transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.1 }}
                    >
                      <Nav.Link
                        className={`text-custom-white me-2 ${activeLink === lowerCaseItem ? "active-link" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveLink(lowerCaseItem);

                          if (lowerCaseItem === "home") {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            setIsSticky(false);
                            setIsHome(true);
                          } else {
                            const section = document.getElementById(lowerCaseItem);
                            if (section) {
                              section.scrollIntoView({ behavior: "smooth", block: "start" });
                            }
                          }
                          setIsOpen(false);
                        }}
                      >
                        {item}
                      </Nav.Link>
                    </motion.div>
                  );
                })}
              </Nav>
            </motion.div>
          )}
        </AnimatePresence>
      </Container>
    </Navbar>
  );
};

export default Header;
